import { useState, useCallback } from "react";

import { cpf } from "cpf-cnpj-validator";

export type options = {
  [key: string]: any;
};

export interface Validation {
  name?: boolean;
  cic?: boolean;
  email?: boolean;
  phone?: boolean;
  password?: boolean;
  username?: boolean;
}

export const useValidation = (
  state: any,
  initialState = {
    name: false,
    cic: false,
    email: false,
    phone: false,
  } as Validation
) => {
  const [errors, setError] = useState(initialState as options);

  const isValid = useCallback(() => {
    return (
      Object.keys(errors).filter((value) => {
        if (value === "cic") {
          return state[value] === "" ? true : !cpf.isValid(state[value], "");
        }
        if (value === "email") {
          return state[value] === ""
            ? true
            : !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(state[value]);
        }

        if (value === "password") {
          return (
            state[value] === "" ||
            !/[A-Za-z0-9]+/.test(state[value]) ||
            !(state[value].length >= 6)
          );
        }

        return state[value] === "" || !/[A-Za-z0-9]+/.test(state[value]);
      }).length !== 0
    );
  }, [errors, state]);

  return {
    errors,
    setError,
    isValid,
  };
};
